import * as PIXI from 'pixi.js'

const Container = () => new PIXI.Container()

export default Container
